import { FlexRow } from '../../../FlexboxReusables/FlexItems'
import styled from 'styled-components'

export const IndentedOption = styled(FlexRow)`
  margin-left: 1.5em;
  display: flex;
  flex-direction: column;
`

export const SubOptionsRow = styled(FlexRow)`
  margin: 0.2em 0;
  justify-content: flex-start;
  cursor: pointer;
`